var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMondpe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.707 0.293001C9.61429 0.199958 9.5041 0.126171 9.38276 0.0758854C9.26143 0.0256001 9.13134 -0.000189449 9 1.04767e-06H2C0.897 1.04767e-06 0 0.897001 0 2V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V7C16.0002 6.86866 15.9744 6.73857 15.9241 6.61724C15.8738 6.4959 15.8 6.38571 15.707 6.293L9.707 0.293001ZM2 2H8.586L14 7.414L14.002 16.588L11.434 14.02C11.784 13.425 12 12.739 12 12C12 9.794 10.206 8 8 8C5.794 8 4 9.794 4 12C4 14.206 5.794 16 8 16C8.739 16 9.425 15.784 10.02 15.434L12.586 18H2V2ZM8 14C6.897 14 6 13.103 6 12C6 10.897 6.897 10 8 10C9.103 10 10 10.897 10 12C10 13.103 9.103 14 8 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondpe);
export default __webpack_public_path__ + "static/media/mondpe.4c239120c0f5b0bdb222d28c59a47db1.svg";
export { ForwardRef as ReactComponent };